import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook para trackear cambios de ruta en Matomo Analytics (SPA tracking)
 * Se debe usar una sola vez en el componente raíz de la aplicación
 */
export const useMatomoTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window._paq) {
      const _paq = window._paq;

      // Trackear page view en cada cambio de ruta
      _paq.push(['setCustomUrl', window.location.href]);
      _paq.push(['setDocumentTitle', document.title]);
      _paq.push(['trackPageView']);

      // Habilitar tracking de clicks en links
      _paq.push(['enableLinkTracking']);
    }
  }, [location]);
};
